import React from 'react';
import Switch from '@/components/ui/Switch';

interface ToggleFieldProps {
  id: string;
  name: string;
  label: string;
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error?: string;
  /** Text under the switch; may hold a link (an error still replaces it). */
  hint?: React.ReactNode;
  required?: boolean;
  disabled?: boolean;
  className?: string;
}

const ToggleField: React.FC<ToggleFieldProps> = ({
  id,
  name,
  label,
  checked,
  onChange,
  error,
  hint,
  required = false,
  disabled = false,
  className = '',
}) => {
  // Handle the Switch's onCheckedChange callback and convert it to a standard onChange event
  // that matches the pattern expected by our form handlers
  const handleToggleChange = (toggleChecked: boolean) => {
    // Create a synthetic change event to match the form's onChange handler signature
    const syntheticEvent = {
      target: {
        name,
        checked: toggleChecked,
        type: 'checkbox',
      },
    } as React.ChangeEvent<HTMLInputElement>;
    
    onChange(syntheticEvent);
  };

  return (
    <div className={`flex flex-col ${className}`}>
      {label && (
        <label htmlFor={id} className="flex items-center mb-1 text-sm font-medium text-gray-700 dark:text-gray-300">
          {label}
          {required && <span className="ml-1 text-error-500">*</span>}
        </label>
      )}
      
      <Switch
        id={id}
        checked={checked}
        onCheckedChange={handleToggleChange}
        disabled={disabled}
        className="mt-1"
      />
      
      {(error || hint) && (
        <p className={`mt-1 text-xs ${error ? 'text-error-500' : 'text-gray-500 dark:text-gray-400'}`}>
          {error || hint}
        </p>
      )}
    </div>
  );
};

export { ToggleField }; 